<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="ch01"><strong>CONTENTS</strong></a></p><a id="ch01">
</a><p class="cont"><a id="ch01"></a><a class="nounder" href="#/xhtml/ch02#ch02">Getting Started</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/ch03#ch03">Shape Up</a></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Head Over Heels</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Let’s Face It</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Mood Swings</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Body Building</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">You Know the Type</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Measuring Up</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Lights, Camera, Action!</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Body Language</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Dress ’Em Up</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Give ’Em Props</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">You’ve Got Males!</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">Ladies’ Night</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Kidding Around</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">Grow Up!</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">Forget Me Not</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch19#ch19" title="Link target outside of Sample">Opposites Attract</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch20#ch20" title="Link target outside of Sample">It’s Alive!</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch21#ch21" title="Link target outside of Sample">Get Graphic</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch22#ch22" title="Link target outside of Sample">Find Your Own Style</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?7367065a